export default __webpack_public_path__ + "icon_login.ef60af916e75513ff2c237b464010c7b.svg";